$(function () {

  $('.menu-btn').on('click', function(){
    $('.gmenu').toggleClass('is-active');
    $('.menu-btn').toggleClass('close');
    $('#fix-header').toggleClass('menu-open');
    $('body').toggleClass('active');
    $('.subinfo').toggleClass('active');
  });

  const headNav = $('#fix-header');
  $(window).on('scroll', function () {
    if($(this).scrollTop() > 600 && !headNav.hasClass('fixed')) {
      headNav.addClass('fixed');
    } else if($(this).scrollTop() < 600 && headNav.hasClass('fixed')) {
      headNav.removeClass('fixed');
    }
  });



});

jQuery(function($) {
  $(document).on('click', '.gmenu a[href^="#"], .gmenu a[href^="#"] *', function(e) {
    e.preventDefault();

    const $link = $(this).closest('a[href^="#"]');
    console.log('リンククリック発火', $link.attr('href'));

    const $gmenu = $('.gmenu');
    console.log('gmenu before:', $gmenu.attr('class'));

    $gmenu.removeClass('is-active');

    setTimeout(() => {
      console.log('gmenu after:', $gmenu.attr('class'));
    }, 10);

    $('.menu-btn').removeClass('close');
    $('#fix-header').removeClass('menu-open');
    $('body').removeClass('active');
    $('.subinfo').removeClass('active');

    // スクロール移動
    const target = $($link.attr('href'));
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 600);
    }
  });
});



